import { api } from './api.js';

export const DEFAULT_MANUAL_ALLOCATION_TIMEOUT_SEC = 45;

let cachedTimeouts = null;

/**
 * Fetches system timeout configuration from backend /config/timeouts
 * Falls back to 45 seconds if request fails or is offline
 */
export const getTimeoutConfig = async () => {
  if (cachedTimeouts) return cachedTimeouts;
  try {
    const res = await api.get('/config/timeouts');
    const data = res?.data?.data || res?.data;
    if (data && typeof data === 'object') {
      cachedTimeouts = data;
      return cachedTimeouts;
    }
  } catch (err) {
    // Silently fall back to standard 45s without breaking UI
    console.warn('⚠️ [configService] Using fallback timeout configuration (45s):', err?.message || err);
  }
  return {
    manual_allocation_timeout_sec: DEFAULT_MANUAL_ALLOCATION_TIMEOUT_SEC,
    driver_response_timeout_sec: 300,
  };
};

/**
 * Synchronous / cached getter with 45s safe default
 */
export const getManualAllocationTimeoutSeconds = () => {
  return cachedTimeouts?.manual_allocation_timeout_sec || DEFAULT_MANUAL_ALLOCATION_TIMEOUT_SEC;
};
